import React, { useRef, useEffect, useState } from "react";
import { motion, useMotionValue } from "framer-motion";
import "./Colaboraciones.css";

const images = [
  "/img/carousel1.png",
  "/img/carousel2.png",
  "/img/carousel3.png",
  "/img/carousel4.png",
  "/img/carousel5.png",
  "/img/carousel6.png",
  "/img/carousel7.png",
  "/img/carousel8.png",
  "/img/carousel9.png",
  "/img/carousel10.png",
  "/img/carousel11.png",
  "/img/carousel12.png",
  "/img/carousel13.png",
  "/img/carousel14.png",
  "/img/carousel15.png",
  "/img/carousel16.png",  
  "/img/carousel17.png",
  "/img/carousel18.png",
  "/img/carousel19.png",
  "/img/carousel20.png",
  "/img/carousel21.png",
  "/img/carousel22.png",
  "/img/carousel23.png",
  "/img/carousel24.png",
  "/img/carousel25.png",
  "/img/carousel26.png",
  "/img/carousel27.png",
  "/img/carousel28.png",
  "/img/carousel29.png",
  "/img/carousel30.png",
  "/img/carousel31.png",
  "/img/carousel32.png",
  "/img/carousel33.png",
  "/img/carousel34.png",
  "/img/logoatrium.jpg",
  "/img/eubusiness.png",
  "/img/iatext.png",
];

const CarouselRow = ({ rowImages, direction = -1 }) => {
  const scrollRef = useRef(null);
  const containerRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  
  const x = useMotionValue(0);
  const velocityRef = useRef(0);
  const initializedRef = useRef(false);

  useEffect(() => {
    const oneSetWidth = scrollRef.current ? scrollRef.current.scrollWidth / 3 : 0;
    
    const unsubscribe = x.on("change", (latest) => {
      if (oneSetWidth <= 0) return;
      
      if (latest <= -2 * oneSetWidth) {
        x.set(latest + oneSetWidth);
      } else if (latest >= 0) {
        x.set(latest - oneSetWidth);
      }
    });

    return () => unsubscribe();
  }, [x]);

  useEffect(() => {
    let animationId;
    
    const animate = () => {
      if (scrollRef.current) {
        const oneSetWidth = scrollRef.current.scrollWidth / 3;
        
        if (!initializedRef.current && oneSetWidth > 0) {
          x.set(-oneSetWidth);
          initializedRef.current = true;
        }

        if (!isDragging) {
          const currentX = x.get();
          const baseSpeed = isPaused ? 0 : 0.6 * direction;
          let nextX = currentX + baseSpeed + velocityRef.current;
          x.set(nextX);
          
          velocityRef.current *= 0.95;
          if (Math.abs(velocityRef.current) < 0.05) velocityRef.current = 0;
        }
      }
      
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, [isPaused, isDragging, direction, x]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleWheel = (e) => {
      e.preventDefault();
      velocityRef.current += e.deltaY * 0.15 * direction;
    };

    container.addEventListener("wheel", handleWheel, { passive: false });
    return () => container.removeEventListener("wheel", handleWheel);
  }, [direction]);

  return (
    <div 
      className="colab-carousel-wrapper"
      ref={containerRef}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <motion.div 
        className="colab-carousel-track" 
        ref={scrollRef}
        style={{ x }}
        drag="x"
        onDragStart={() => setIsDragging(true)}
        onDragEnd={(e, info) => {
          setIsDragging(false);
          velocityRef.current = info.velocity.x * 0.01;
        }}
        dragElastic={0}
      >
        {[...rowImages, ...rowImages, ...rowImages].map((img, index) => (
          <div className="colab-carousel-item" key={index}>
            <img 
              src={img} 
              alt={`Colaboración ${index}`} 
              className="colab-carousel-image select-none pointer-events-none" 
              loading="lazy"
              draggable="false"
            />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

const Colaboraciones = () => {
  // 18 imágenes en la primera fila y el resto (19) en la segunda
  const row1 = images.slice(0, 18);
  const row2 = images.slice(18);

  return (
    <div className="colaboraciones-container" id="colaboraciones">
      <h2 className="colaboraciones-title">Contamos con el respaldo y la colaboración de:</h2>
      
      <CarouselRow rowImages={row1} direction={-1} />
      <div style={{ height: '20px' }}></div> {/* Espacio entre filas */}
      <CarouselRow rowImages={row2} direction={1} />
    </div>
  );
};

export default Colaboraciones;
